"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthServiceLive = void 0;
const mystake_auth_frontend_sdk_1 = require("@boulevard1/mystake-auth-frontend-sdk");
const HttpProvider_1 = require("../utils/HttpProvider");
const constants_1 = require("../utils/constants");
const errors_1 = require("../errors");
const SessionService_1 = require("./SessionService");
class AuthServiceLive {
    constructor(firebaseAuthConfig) {
        this.sessionService = SessionService_1.SessionService.create();
        this.authService = mystake_auth_frontend_sdk_1.FirebaseAuthService.getInstance(firebaseAuthConfig);
        this.isNodeEnv = typeof process !== "undefined" && process.versions != null && process.versions.node != null;
        this.authService.onAuthStateChanged((user) => __awaiter(this, void 0, void 0, function* () {
            if (!user && !this.isNodeEnv) {
                this.sessionService.removeCurrentSessionId();
            }
        }));
    }
    loginWithUsernameAndPassword(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield HttpProvider_1.httpProvider.post("/user/account-status", {
                username,
                password,
            });
            if (res.data.status === false) {
                return {
                    status: res.data.status,
                    message: res.data.message,
                    payload: res.data.payload,
                };
            }
            const accountStatus = res.data.payload;
            if (accountStatus.isInactive) {
                throw new errors_1.BadRequest("Password is incorrect.");
            }
            const user = yield this.authService.loginWithEmail(accountStatus.email, password);
            if (user) {
                yield this.sessionService.createSession({ userId: user.user.uid });
            }
            return {
                status: true,
                message: "Login successful",
                payload: null,
            };
        });
    }
    signOut() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.sessionService.revokeSession();
            yield this.authService.signOut();
            this.sessionService.removeCurrentSessionId();
        });
    }
    loginWithGoogle() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.authService.loginWithGoogle();
            const authToken = yield result.user.getIdToken();
            return authToken;
        });
    }
    signUp(user, selectedSubscriptionPlan, selectedTier) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield HttpProvider_1.httpProvider.post(constants_1.CREATE_ACCOUNT, {
                user,
                selectedSubscriptionPlan,
                selectedTier,
            });
            const newUser = yield this.authService.signInWithCustomToken(result.data.payload.customToken);
            if (newUser) {
                yield this.sessionService.createSession({ userId: newUser.user.uid });
            }
            const authToken = yield newUser.user.getIdToken();
            return authToken;
        });
    }
    currentUser() {
        return __awaiter(this, void 0, void 0, function* () {
            const currentUser = yield this.authService.currentUser();
            return currentUser;
        });
    }
    getIdToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const authToken = yield this.authService.getIdToken();
            return authToken;
        });
    }
    createNomineeAccount(userId, createNomineeAccountRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/nominee/user/${userId}`, createNomineeAccountRequestBody);
            const customToken = response.data.payload;
            const userCredentials = yield this.authService.signInWithCustomToken(customToken);
            if (userCredentials) {
                yield this.sessionService.createSession({ userId: userCredentials.user.uid });
            }
            const authToken = yield userCredentials.user.getIdToken();
            return {
                status: true,
                message: "Account creation and login successful",
                payload: authToken,
            };
        });
    }
    createInvestorAccount(userId, createInvestorRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/investor/user/${userId}`, createInvestorRequestBody);
            const customToken = response.data.payload;
            const userCredentials = yield this.authService.signInWithCustomToken(customToken);
            if (userCredentials) {
                yield this.sessionService.createSession({ userId: userCredentials.user.uid });
            }
            const authToken = yield userCredentials.user.getIdToken();
            return {
                status: true,
                message: "Account creation and login successful",
                payload: authToken,
            };
        });
    }
    createAdminAccount(adminUserId, companyId, createNewAdminAccountRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/admin/${companyId}/user/${adminUserId}`, createNewAdminAccountRequestBody);
            const customToken = response.data.payload;
            const userCredentials = yield this.authService.signInWithCustomToken(customToken);
            if (userCredentials) {
                yield this.sessionService.createSession({ userId: userCredentials.user.uid });
            }
            const authToken = yield userCredentials.user.getIdToken();
            return {
                status: true,
                message: "Account creation and login successful",
                payload: authToken,
            };
        });
    }
}
exports.AuthServiceLive = AuthServiceLive;
//# sourceMappingURL=AuthServiceLive.js.map